import { call, put, takeLatest, select, takeEvery } from 'redux-saga/effects';
import { inventory, loading, modal, serviceRequest, toast } from '../types';
import scogo_apis from '../scogo_apis';
import { isUserScogoMember } from '../utils/common';
import { RegionsType, TicketAgentRole } from '../pages/Ticket/TicketController';


export function* getInventoryLocations(action) {
    const { query, limit, page, payload, type, dropdown, is_repair_center, site_id } = action.payload;
    const newLoggedUserData = yield select(state => state.auth.newLoggedUserData);
    const ticket_agent_roles = newLoggedUserData.user.roles.map(role => role.ticket_agent_role)
    let queryParams = { limit, page, type };
    yield put({ type: inventory.SET_LOCATION_FILTER_DATA, payload: action.payload });
    if (payload) queryParams = { ...queryParams, ...payload };
    if (query) queryParams = { ...queryParams, q: query };
    if (dropdown && is_repair_center) queryParams = { ...queryParams, is_repair_center: true };
    if (site_id) queryParams = { ...queryParams, external_id: site_id };

    const is_ticket_role_is_sp_fe_psp_cluster = ticket_agent_roles.find((elem) => [TicketAgentRole.SP, TicketAgentRole.FE, TicketAgentRole.CLUSTER, TicketAgentRole.PSP].includes(elem));

    if (dropdown && !is_ticket_role_is_sp_fe_psp_cluster) {
        queryParams = { ...queryParams, give_public: true }
    };

    Object.keys(RegionsType).forEach(key => {
        delete queryParams[key];
    })

    try {
        if (dropdown && is_repair_center) {
            yield put({ type: loading.SET_REPAIR_CENTER_LOADING, payload: true });
        } else if (dropdown) {
            yield put({ type: loading.SET_INVENTORY_DROPDOWN_LOCATIONS_LOADING, payload: true });
        } else {
            yield put({ type: loading.SET_INVENTORY_LOCATIONS_LOADING, payload: true });
        }
        const response = yield call(scogo_apis.inventory.getInventoryLocations, {}, {}, queryParams);
        if (response.status === 200) {
            if (dropdown) {
                let data = response.data.data.map(item => ({ id: item.id, label: item.external_id, key: item.id, location: item, value: item.id, owners: item.owners }));
                if (is_repair_center) {
                    yield put({ type: inventory.GET_REPAIR_CENTER_DROPDOWN_SUCCESS, payload: { data, query } });
                }
                else if (site_id) {
                    yield put({ type: inventory.GET_INVENTORY_DROPDOWN_LOCATIONS_SITE_ID_SUCCESS, payload: { data, type, query, site_id } });
                } else {
                    yield put({ type: inventory.GET_INVENTORY_DROPDOWN_LOCATIONS_SUCCESS, payload: { data, type, query, } });
                }
            } else {
                yield put({ type: inventory.GET_INVENTORY_LOCATIONS_SUCCESS, payload: response.data });
                const ids = response?.data?.data?.map((location) => location.id);
                if (ids.length > 0) {
                    yield put({ type: inventory.GET_INVENTORY_LOCATION_DETAILS_REQUEST, payload: { ids: ids.join(',') } });
                }
            }
        } else {
            yield put({ type: inventory.GET_INVENTORY_LOCATIONS_FAILURE, payload: response.data });
        }
    } catch (error) {
        yield put({ type: inventory.GET_INVENTORY_LOCATIONS_FAILURE, payload: error });
    } finally {
        if (dropdown && is_repair_center) {
            yield put({ type: loading.SET_REPAIR_CENTER_LOADING, payload: false });
        } else if (dropdown) {
            yield put({ type: loading.SET_INVENTORY_DROPDOWN_LOCATIONS_LOADING, payload: false });
        } else {
            yield put({ type: loading.SET_INVENTORY_LOCATIONS_LOADING, payload: false });
        }
    }
};

export function* createInventoryLocation(action) {
    const { payload, formName, onSuccess, onError } = action.payload

    try {
        if (payload.create_end_user) {
            const endUserResponse = yield call(scogo_apis.org.postEntities, {}, { orgId: payload.org_id }, {}, { name: payload.create_end_user, type: 'END_USER' });
            delete payload.create_end_user;
            if (endUserResponse.status === 201) {
                payload.end_user_id = endUserResponse.data.data.id
            }
        }
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const res = yield call(scogo_apis.inventory.createInventoryLocations, {}, {}, {}, payload)
        if (res.status === 201) {
            yield put({
                type: toast.SEND_TOAST, payload: {
                    status: 'success',
                    message: `${payload.type} added successfully`,
                }
            });
            yield put({ type: inventory.REFRESH_INVENTORY_LOCATIONS_REQUEST });
            onSuccess && onSuccess();
        }
    } catch (err) {
        console.log('err:', err)
        const message = err?.response?.data?.messages?.[0] || 'Something went wrong';
        yield put({
            type: toast.SEND_TOAST, payload: {
                status: 'danger',
                message,
            }
        });
        if (onError) onError(message);
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* refreshInventoryLocations(action) {
    try {
        const queryParams = yield select(state => state.inventory.locationFilterData);
        yield put({ type: inventory.GET_INVENTORY_LOCATIONS_REQUEST, payload: queryParams });
    } catch (error) {
        console.log('error:', error)
    }
}

export function* getAssetsTypeList(action) {
    const { payload, limit, page, query, dropdown } = action.payload;
    let queryParams = { limit, page };
    if (query) queryParams = { ...queryParams, q: query };
    if (payload) queryParams = { ...queryParams, ...payload }

    try {
        yield put({ type: loading.SET_ASSETS_TYPE_DROPDOWN_LOADING, payload: true });
        const response = yield call(scogo_apis.inventory.getAssetTypeList, {}, {}, queryParams);
        if (response.status === 200) {
            if (dropdown) {
                let data = response.data.map(item => ({ id: item.id, label: item.title, key: item.id, assetType: item, value: item.id, fields: item.additional_fields }));
                yield put({ type: inventory.GET_ASSETS_TYPE_DROPDOWN_LIST_SUCCESS, payload: { data, query } });
            } else {
                yield put({ type: inventory.GET_ASSETS_TYPE_LIST_SUCCESS, payload: response.data.data });
            }
        }
    } catch (error) {
        console.log('error:', error)
    } finally {
        yield put({ type: loading.SET_ASSETS_TYPE_DROPDOWN_LOADING, payload: false });
    }

}
export function* updateInventorySite(action) {
    const { id, payload, formName, source, ticketId, onError } = action.payload
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.inventory.updateInventoryLocation, {}, { id }, {}, payload);
        if (response.status === 200) {
            if (source === 'edit_ticket') {
                yield put({ type: serviceRequest.GET_SERVICE_REQUEST_BY_ID_REQUEST, payload: { ticketId, call_after_site_update: true } });
            }
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: inventory.REFRESH_INVENTORY_LOCATIONS_REQUEST })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Inventory site updated successfully' } })
        }
    } catch (err) {
        console.log(err)
        const message = err?.response?.data?.messages?.[0] || 'Something went wrong';
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message } })
        if (onError) onError(message);
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}
export function* editWarehouse(action) {
    const { id, payload } = action.payload

    try {
        const response = yield call(scogo_apis.inventory.editWarehouse, {}, { id }, {}, payload);

        if (response.status === 200) {
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: inventory.REFRESH_INVENTORY_LOCATIONS_REQUEST })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Warehouse updated successfully' } })
        }
    } catch (err) {
        console.log(err)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: err.response.data.messages[0] || 'Something went wrong' } })
    }
}
export function* deleteAsset(action) {
    const { id, formName } = action.payload
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });

    try {
        const response = yield call(scogo_apis.inventory.deleteAsset, {}, { id }, {});
        if (response.status === 200) {

            if (response.data.deleted === false) {
                yield put({
                    type: toast.SEND_TOAST, payload: {
                        status: 'danger',
                        message: response.data.message || 'Something went wrong',
                    }
                })
            } else {
                yield put({ type: modal.CLOSE_MODAL })
                yield put({ type: inventory.REFRESH_ASSETS_REQUEST })
                yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Asset deleted successfully' } })
            }
        }
    } catch (err) {
        console.log(err)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: err.response.data.messages[0] || 'Something went wrong' } })
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });

}
export function* getFilterList(action) {
    const { filter_labels, type } = action.payload

    try {
        const response = yield call(scogo_apis.inventory.locationsFilterList, {}, {}, { type, filter_labels });
        if (response.status === 200) {
            yield put({ type: inventory.GET_LOCATIONS_FILTER_LIST_SUCCESS, payload: response.data.data.data });
        }
    } catch (err) {
        console.log(err)
    }
}


export function* getInventoryDetails(action) {
    const { ids } = action.payload;
    try {
        const response = yield call(scogo_apis.inventory.locationsDetails, {}, {}, { ids });
        if (response.status === 200) {
            yield put({ type: inventory.GET_INVENTORY_LOCATION_DETAILS_SUCCESS, payload: response.data.data });
        }
    } catch (err) {
        console.log(err)
    }
}

export function* deleteLocation(action) {
    const { id, formName } = action.payload
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });

    try {
        const response = yield call(scogo_apis.inventory.deleteLocation, {}, { id }, {});
        if (response.status === 200) {
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: inventory.REFRESH_INVENTORY_LOCATIONS_REQUEST })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Location deleted successfully' } })
        }
    } catch (err) {
        console.log(err)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: err?.response?.data?.messages?.[0] || 'Something went wrong' } })
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}

export function* getLocationById(action) {
    const { id } = action.payload
    yield put({ type: loading.SET_INVENTORY_LOCATIONS_BY_ID_LOADING, payload: true });
    try {
        const response = yield call(scogo_apis.inventory.getLocationById, {}, { id }, {});
        if (response.status === 200) {
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: inventory.GET_INVENTORY_LOCATION_BY_ID_SUCCESS, payload: response.data.data })
        }
    } catch (err) {
        console.log(err)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: err?.response?.data?.messages?.[0] || 'Something went wrong' } })
    }
    yield put({ type: loading.SET_INVENTORY_LOCATIONS_BY_ID_LOADING, payload: false });
}


export function* changeServieRequestWarehouse(action) {
    const { payload, formName } = action.payload
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
    try {
        const response = yield call(scogo_apis.inventory.changeWarehouse, {}, {}, {}, payload);
        if (response.status === 200) {
            yield put({ type: serviceRequest.GET_SERVICE_REQUEST_BY_ID_REQUEST, payload: { ticketId: payload.ticket_id } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Warehouse Changed Successfully!!!' } })
        }
    } catch (err) {
        console.log(err)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: err?.response?.data?.messages?.[0] || 'Something went wrong' } })
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}

export default function* fmSaga() {
    yield takeEvery(inventory.GET_INVENTORY_LOCATIONS_REQUEST, getInventoryLocations);
    yield takeLatest(inventory.REFRESH_INVENTORY_LOCATIONS_REQUEST, refreshInventoryLocations);
    yield takeLatest(inventory.CREATE_INVENTORY_LOCATION_REQUEST, createInventoryLocation);
    yield takeLatest(inventory.GET_ASSETS_TYPE_LIST_REQUEST, getAssetsTypeList);
    yield takeLatest(inventory.UPDATE_INVENTORY_SITE_REQUEST, updateInventorySite);
    yield takeLatest(inventory.EDIT_WAEHOUSE_REQUEST, editWarehouse);
    yield takeLatest(inventory.DELET_SPARE_ASSET_REQUEST, deleteAsset);
    yield takeLatest(inventory.GET_LOCATIONS_FILTER_LIST_REQUEST, getFilterList)
    yield takeLatest(inventory.GET_INVENTORY_LOCATION_DETAILS_REQUEST, getInventoryDetails)
    yield takeLatest(inventory.DELETE_LOCATION_REQUEST, deleteLocation)
    yield takeLatest(inventory.GET_INVENTORY_LOCATION_BY_ID_REQUEST, getLocationById)
    yield takeLatest(inventory.CHANGE_SERVICE_REQUEST_WAREHOUSE_REQUEST, changeServieRequestWarehouse)
}